import { COMBO_TIERS, type ComboTier } from "../content/combo";
import type { Answer } from "./round";

/*
  Combos: right answers in a row, read straight from a round's answer log.
  Nothing here feeds back into the game; the screen reads it to show the
  badge and the bursts, and the result screen shows the best run.
*/

/** Right answers in a row at the end of the log (a Pass counts as wrong). */
export function comboOf(log: readonly Answer[]): number {
  let n = 0;
  for (let i = log.length - 1; i >= 0 && log[i]!.correct; i--) n++;
  return n;
}

/** The longest run of right answers anywhere in the log. */
export function bestCombo(log: readonly Answer[]): number {
  let best = 0;
  let run = 0;
  for (const a of log) {
    run = a.correct ? run + 1 : 0;
    if (run > best) best = run;
  }
  return best;
}

/** The tier a run of `n` is in, or null below the first mark. */
export function comboTier(n: number, tiers: readonly ComboTier[] = COMBO_TIERS): ComboTier | null {
  let found: ComboTier | null = null;
  for (const t of tiers) if (n >= t.from) found = t;
  return found;
}

/** The first mark: the run length the badge appears at. */
export function comboStart(tiers: readonly ComboTier[] = COMBO_TIERS): number {
  return tiers[0]?.from ?? Infinity;
}

/** Whether a run of `n` has just reached a tier (so the word and the burst show). */
export function isTierStep(n: number, tiers: readonly ComboTier[] = COMBO_TIERS): boolean {
  return tiers.some((t) => t.from === n);
}
